
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jXTzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e88ea34f6d81d425$export$2e2bcd8739ae039; });

var $9D0e3 = parcelRequire("9D0e3");

var $dPl4k = parcelRequire("dPl4k");

var $XAEGR = parcelRequire("XAEGR");
var $e88ea34f6d81d425$var$_process$env;
var $e88ea34f6d81d425$var$ExportedAnalyticsContext;
if (typeof $XAEGR !== "undefined" && $XAEGR !== null && ($e88ea34f6d81d425$var$_process$env = {}, true) && $e88ea34f6d81d425$var$_process$env !== void 0 && $e88ea34f6d81d425$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $e88ea34f6d81d425$var$ExportedAnalyticsContext = (0, $dPl4k.default);
else $e88ea34f6d81d425$var$ExportedAnalyticsContext = (0, $9D0e3.default);
var $e88ea34f6d81d425$export$2e2bcd8739ae039 = $e88ea34f6d81d425$var$ExportedAnalyticsContext;

});
parcelRegister("9D0e3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7027ee6886356bbf$export$2e2bcd8739ae039; });

var $4Z10T = parcelRequire("4Z10T");

var $6rQsM = parcelRequire("6rQsM");

var $9TYIF = parcelRequire("9TYIF");

var $inya7 = parcelRequire("inya7");

var $k3rDa = parcelRequire("k3rDa");

var $hiHUU = parcelRequire("hiHUU");

var $8A1dt = parcelRequire("8A1dt");

var $6NMpj = parcelRequire("6NMpj");

var $iSvIT = parcelRequire("iSvIT");

var $4J1z5 = parcelRequire("4J1z5");

var $lEO1D = parcelRequire("lEO1D");
function $7027ee6886356bbf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7027ee6886356bbf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $8A1dt.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $8A1dt.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $hiHUU.default)(this, result);
    };
}
function $7027ee6886356bbf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $7027ee6886356bbf$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).func
};
var $7027ee6886356bbf$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $7027ee6886356bbf$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, $k3rDa.default)(AnalyticsContext, _Component);
    var _super = $7027ee6886356bbf$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, $6rQsM.default)(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, $6NMpj.default)((0, $inya7.default)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $6NMpj.default)((0, $inya7.default)(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $7027ee6886356bbf$var$noop : _this$context$getAtla;
            return [].concat((0, $4Z10T.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $6NMpj.default)((0, $inya7.default)(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $7027ee6886356bbf$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $9TYIF.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lEO1D.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $iSvIT.Component));
(0, $6NMpj.default)($7027ee6886356bbf$var$AnalyticsContext, "contextTypes", $7027ee6886356bbf$var$ContextTypes);
(0, $6NMpj.default)($7027ee6886356bbf$var$AnalyticsContext, "childContextTypes", $7027ee6886356bbf$var$ContextTypes);
var $7027ee6886356bbf$export$2e2bcd8739ae039 = $7027ee6886356bbf$var$AnalyticsContext;

});

parcelRegister("dPl4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a110619b8ce731eb$export$2e2bcd8739ae039; });

var $4Z10T = parcelRequire("4Z10T");

var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");

var $5kXR2 = parcelRequire("5kXR2");

var $8T92u = parcelRequire("8T92u");
var $a110619b8ce731eb$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $8T92u.useTrackedRef)(data);
    var analyticsContext = (0, $5kXR2.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $iSvIT.useCallback)(function() {
        return [].concat((0, $4Z10T.default)(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $iSvIT.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lEO1D.default).Provider, {
        value: value
    }, children);
};
var $a110619b8ce731eb$export$2e2bcd8739ae039 = $a110619b8ce731eb$var$AnalyticsContext;

});


parcelRegister("WKdxa", function(module, exports) {
$parcel$export(module.exports, "SignupAnalyticsContext", function () { return (parcelRequire("1qjOG")).SignupAnalyticsContext; });
$parcel$export(module.exports, "SignupFormContextProvider", function () { return (parcelRequire("cRAeL")).SignupFormContextProvider; });
$parcel$export(module.exports, "useSignupFormContext", function () { return (parcelRequire("cRAeL")).useSignupFormContext; });
parcelRequire("1qjOG");
parcelRequire("cRAeL");

});
parcelRegister("1qjOG", function(module, exports) {

$parcel$export(module.exports, "SignupAnalyticsContext", function () { return $b53aa7ce3d8316c8$export$1bde86e98d910a3d; });

var $loA2J = parcelRequire("loA2J");

var $jXTzN = parcelRequire("jXTzN");
const $b53aa7ce3d8316c8$export$1bde86e98d910a3d = ({ children: children, productName: productName })=>{
    const defaultAnalyticsData = {
        schemaVersion: 1,
        action: "event",
        event: "event",
        // event verb, in past tense (eg, "clicked")
        eventType: "ui",
        eventComponent: "signUp",
        // name of component being interacted with, in camelCase
        eventContainer: "signUp",
        // container, in camelCase; eg, component that contains this component within a page
        eventColumn: "signUpForm",
        // should be bundleInformation or signUpForm
        eventName: "signupFormJSWv2",
        uuid: "signupFormJSWv2",
        productName: // required for Magnolia events, unique id for a given component if available
        productName
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jXTzN.default), {
        data: defaultAnalyticsData,
        children: children
    });
};

});

parcelRegister("cRAeL", function(module, exports) {

$parcel$export(module.exports, "useSignupFormContext", function () { return $3e4b5876cc14462a$export$700674aef42f5290; });
$parcel$export(module.exports, "SignupFormContextProvider", function () { return $3e4b5876cc14462a$export$aaba79cce552c89; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eZAyW = parcelRequire("eZAyW");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $gkhN4 = parcelRequire("gkhN4");

var $lrVTP = parcelRequire("lrVTP");
const { IDENTITY_USER_SIGNUP_API: $3e4b5876cc14462a$var$IDENTITY_USER_SIGNUP_API } = (0, $jgJpJ.UfoCustomTimingKey);
const $3e4b5876cc14462a$export$46bf5b535cc4ff18 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $3e4b5876cc14462a$export$700674aef42f5290 = ()=>{
    const context = (0, $iSvIT.useContext)($3e4b5876cc14462a$export$46bf5b535cc4ff18);
    if (!context) throw new Error("useSignupFormContext must be used within a SignupFormContextProvider");
    return context;
};
const $3e4b5876cc14462a$export$aaba79cce552c89 = ({ bundle: bundle, children: children, edition: edition = "free", isEmbedded: isEmbedded = false, useCurrentRedirect: useCurrentRedirect, customHeader: customHeader })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const [isEmailValid, setIsEmailValid] = (0, $iSvIT.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $iSvIT.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $iSvIT.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $iSvIT.useState)(false);
    const [formError, setFormError] = (0, $iSvIT.useState)(false);
    const [email, setEmail] = (0, $iSvIT.useState)("");
    const [typeAheadEmail, setTypeAheadEmail] = (0, $iSvIT.useState)("");
    const [onSubmitProps, setOnSubmitProps] = (0, $iSvIT.useState)(undefined);
    const [recaptchaFailedToLoad, setRecaptchaFailedToLoad] = (0, $iSvIT.useState)(false);
    const [recaptchaRetryTimeRemainingSecond, setRecaptchaRetryTimeRemainingSecond] = (0, $iSvIT.useState)(60);
    const localePath = (0, $jgJpJ.getLocalePath)(intl.locale);
    const signupClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { executeRecaptcha: executeRecaptcha } = (0, $eZAyW.useGoogleReCaptcha)();
    const continueParam = (0, $jgJpJ.getContinueParam)(location);
    const redirectTo = useCurrentRedirect ? window.location.href : continueParam ? continueParam : (0, $jgJpJ.getNameYourSiteRedirectUrl)({
        bundle: bundle,
        edition: edition,
        localePath: localePath
    });
    const products = (0, $jgJpJ.getProductsFromBundle)(bundle);
    // default experiment params
    let identityCobranding = "wac";
    if (bundle === "confluence") identityCobranding = "wac--otp-confluence";
    else if (bundle === "jira-software") identityCobranding = "wac--otp-jira";
    (0, $iSvIT.useEffect)(()=>{
        (0, $jgJpJ.trackSignFormLoad)(createAnalyticsEvent);
        (0, $jgJpJ.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent
    ]);
    // Embedded form does not show product logo
    const showProductLogo = !isEmbedded;
    const productKey = products.map(({ productKey: productKey })=>productKey).join(",");
    const productName = products.map(({ productName: productName })=>productName).join(" + ");
    const productLogos = products.map(({ productLogo: productLogo })=>productLogo);
    const onSubmitWithReCAPTCHA = (0, $iSvIT.useCallback)(async ({ email: email })=>{
        var _products_;
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $jgJpJ.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        setOnSubmitProps({
            email: email
        });
        if (!executeRecaptcha && recaptchaRetryTimeRemainingSecond > 0) {
            // set trigger that will wait for Recaptcha retry logic
            setFormError(true);
            setIsSubmitting(true);
            setRecaptchaFailedToLoad(true);
            return;
        }
        setRecaptchaFailedToLoad(false);
        // Start UFO to begin duration measurements for account creation
        (0, $jgJpJ.ufoEventAccountCreation).start({
            productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
            webPlatform: "bxp-ui"
        });
        const gRecaptchaResponse = await (0, $jgJpJ.getRecaptcha)(email, executeRecaptcha);
        (0, $jgJpJ.ufoEventAccountCreation).setCustomData({
            gRecaptchaResponse: gRecaptchaResponse !== null && gRecaptchaResponse !== void 0 ? gRecaptchaResponse : "none",
            executeRecaptchaExists: Boolean(executeRecaptcha),
            reactComponent: "SignupFormContextProvider"
        });
        // Handle missing reCAPTCHA response
        if (!gRecaptchaResponse) {
            (0, $jgJpJ.trackRecaptchaFailure)(createAnalyticsEvent, "bxp-ui-signup-form");
            const invalidRecaptchaError = new Error("Missing reCAPTCHA token");
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "SignupFormContextProvider"
                },
                error: invalidRecaptchaError
            });
            throw invalidRecaptchaError;
        }
        (0, $jgJpJ.trackFormSubmit)(createAnalyticsEvent, (_products_ = products[0]) === null || _products_ === void 0 ? void 0 : _products_.productKey, edition);
        const existingUserRedirectUrl = await (0, $jgJpJ.getMethodsAvailableRedirection)({
            email: email,
            application: identityCobranding,
            signupClient: signupClient,
            createAnalyticsEvent: createAnalyticsEvent,
            successRedirect: redirectTo
        }).catch((error)=>{
            setFormError(true);
            (0, $jgJpJ.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
        if (existingUserRedirectUrl) {
            window.location.assign(existingUserRedirectUrl.replace("/initiate/password", ""));
            return;
        }
        const newUserRedirectTo = redirectTo + `&n2n=true`;
        (0, $jgJpJ.ufoEventAccountCreation).startSubstep($3e4b5876cc14462a$var$IDENTITY_USER_SIGNUP_API);
        await signupClient.userSignup({
            application: identityCobranding,
            displayName: "",
            email: email,
            gRecaptchaResponse: gRecaptchaResponse,
            locale: intl.locale,
            products: products.map(({ productKey: productKey })=>({
                    productKey: productKey,
                    edition: edition
                })),
            redirectTo: newUserRedirectTo
        }).then(({ otpRedirect: otpRedirect })=>{
            (0, $jgJpJ.ufoEventAccountCreation).endSubstep($3e4b5876cc14462a$var$IDENTITY_USER_SIGNUP_API);
            if (!otpRedirect) throw new Error("No OTP redirect");
            // Reliability SLO "good event" metric emitted for submit account creation
            (0, $jgJpJ.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "SignupFormContextProvider"
                }
            });
            window.location.assign(otpRedirect);
            setHasSubmitted(true);
        }).catch((error)=>{
            // Reliability SLO "bad event" metric emitted for submit account creation
            (0, $jgJpJ.ufoEventAccountCreation).endSubstep($3e4b5876cc14462a$var$IDENTITY_USER_SIGNUP_API);
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "SignupFormContextProvider"
                },
                error: error
            });
            setFormError(true);
            (0, $jgJpJ.trackSignupFailure)(createAnalyticsEvent);
            throw new Error(error);
        });
        (0, $jgJpJ.trackSubmitSuccess)(createAnalyticsEvent);
        (0, $jgJpJ.trackRedirectCheckEmail)(createAnalyticsEvent);
        setEmail(email);
    }, [
        bundle,
        createAnalyticsEvent,
        edition,
        executeRecaptcha,
        identityCobranding,
        intl.locale,
        isEmailValid,
        products,
        redirectTo,
        signupClient
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (recaptchaFailedToLoad && recaptchaRetryTimeRemainingSecond <= 0) (0, $jgJpJ.ufoEventAccountCreation).failure({
            customData: {
                reactComponent: "SignupFormContextProvider",
                recaptchaRetryTimeRemainingSecond: 0
            },
            error: new Error("Recaptcha retry failed")
        });
        if (onSubmitProps && recaptchaFailedToLoad && executeRecaptcha) onSubmitWithReCAPTCHA(onSubmitProps).then(()=>{
            (0, $jgJpJ.ufoEventAccountCreation).success({
                customData: {
                    reactComponent: "SignupFormContextProvider",
                    analyticsEvent: "succeeded",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                }
            });
        }).catch((error)=>{
            setFormError(true);
            setIsSubmitting(false);
            (0, $jgJpJ.ufoEventAccountCreation).failure({
                customData: {
                    reactComponent: "SignupFormContextProvider",
                    analyticsEvent: "errored",
                    recaptchaRetryTimeRemainingSecond: recaptchaRetryTimeRemainingSecond
                },
                error: error
            });
            return;
        });
    }, [
        executeRecaptcha,
        recaptchaFailedToLoad,
        onSubmitProps,
        recaptchaRetryTimeRemainingSecond
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!recaptchaFailedToLoad) return;
        if (recaptchaRetryTimeRemainingSecond <= 0) return;
        const intervalId = setInterval(()=>{
            setRecaptchaRetryTimeRemainingSecond(recaptchaRetryTimeRemainingSecond - 1);
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        recaptchaFailedToLoad,
        recaptchaRetryTimeRemainingSecond
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($3e4b5876cc14462a$export$46bf5b535cc4ff18.Provider, {
        value: {
            bundle: bundle,
            isEmbedded: isEmbedded,
            email: email,
            formError: formError,
            hasSubmitted: hasSubmitted,
            isSubmitting: isSubmitting,
            identityCobranding: identityCobranding,
            isEmailValid: isEmailValid,
            isReadyForInvalid: isReadyForInvalid,
            onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA,
            productKey: productKey,
            edition: edition,
            productLogos: productLogos,
            products: products,
            productName: productName,
            redirectTo: redirectTo,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            showProductLogo: showProductLogo,
            typeAheadEmail: typeAheadEmail,
            setTypeAheadEmail: setTypeAheadEmail,
            customHeader: customHeader
        },
        children: children
    });
};

});


parcelRegister("9DfPf", function(module, exports) {
$parcel$export(module.exports, "AnimatedSocialProof", function () { return (parcelRequire("fVvJ6")).AnimatedSocialProof; });
$parcel$export(module.exports, "ButtonSubmit", function () { return (parcelRequire("6PtZq")).ButtonSubmit; });
$parcel$export(module.exports, "EmailForm", function () { return (parcelRequire("aGugh")).EmailForm; });
$parcel$export(module.exports, "EulaText", function () { return (parcelRequire("bcjjH")).EulaText; });
$parcel$export(module.exports, "ExistingProductText", function () { return (parcelRequire("9cpbu")).ExistingProductText; });
$parcel$export(module.exports, "InputEmail", function () { return (parcelRequire("5jy1A")).InputEmail; });
$parcel$export(module.exports, "SignInButtons", function () { return (parcelRequire("jMrU6")).SignInButtons; });
parcelRequire("72EKa");
parcelRequire("aYz6E");
parcelRequire("swQEv");
parcelRequire("4XUO1");
parcelRequire("5CXM7");
parcelRequire("c5qwq");
parcelRequire("7ubNM");

});
parcelRegister("72EKa", function(module, exports) {
$parcel$export(module.exports, "AnimatedSocialProof", function () { return (parcelRequire("fVvJ6")).AnimatedSocialProof; });
parcelRequire("fVvJ6");

});
parcelRegister("fVvJ6", function(module, exports) {

$parcel$export(module.exports, "AnimatedSocialProof", function () { return $b0ce53f5c3f7960f$export$b9b8b5eca0edeb76; });
/* animated-social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("goy7h");
var $hsIsf = parcelRequire("hsIsf");
var $gLfKe = parcelRequire("gLfKe");
var $gFJSc = parcelRequire("gFJSc");
var $6rfnk = parcelRequire("6rfnk");
var $b32Sf = parcelRequire("b32Sf");
var $kKkgA = parcelRequire("kKkgA");
var $81noK = parcelRequire("81noK");
const $b0ce53f5c3f7960f$var$carouselCss = null;
const $b0ce53f5c3f7960f$var$trackCss = null;
const $b0ce53f5c3f7960f$var$imageCss = null;
const $b0ce53f5c3f7960f$var$logos = [
    (0, $hsIsf.DominosLogo),
    (0, $gLfKe.SquareLogo),
    (0, $gFJSc.EbayLogo),
    (0, $6rfnk.CiscoLogo),
    (0, $b32Sf.FordLogo),
    (0, $kKkgA.PaypalLogo),
    (0, $81noK.NasaLogo)
];
const $b0ce53f5c3f7960f$export$b9b8b5eca0edeb76 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _4t3ildb6 _kqswh2mm _1bsb1osq _1mjbglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_y44v9j94 _1e0c1txw _kqswstnw"
            ]),
            children: [
                ...$b0ce53f5c3f7960f$var$logos,
                ...$b0ce53f5c3f7960f$var$logos
            ].map((Logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4t3ildb6 _1bsbymf6 _12l2zwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)(Logo, {})
                }, index))
        })
    });

});
parcelRegister("goy7h", function(module, exports) {
$parcel$export(module.exports, "CiscoLogo", function () { return (parcelRequire("6rfnk")).CiscoLogo; });
$parcel$export(module.exports, "DominosLogo", function () { return (parcelRequire("hsIsf")).DominosLogo; });
$parcel$export(module.exports, "EbayLogo", function () { return (parcelRequire("gFJSc")).EbayLogo; });
$parcel$export(module.exports, "FordLogo", function () { return (parcelRequire("b32Sf")).FordLogo; });
$parcel$export(module.exports, "NasaLogo", function () { return (parcelRequire("81noK")).NasaLogo; });
$parcel$export(module.exports, "PaypalLogo", function () { return (parcelRequire("kKkgA")).PaypalLogo; });
$parcel$export(module.exports, "SquareLogo", function () { return (parcelRequire("gLfKe")).SquareLogo; });
parcelRequire("6rfnk");
parcelRequire("hsIsf");
parcelRequire("gFJSc");
parcelRequire("b32Sf");
parcelRequire("81noK");
parcelRequire("kKkgA");
parcelRequire("gLfKe");

});
parcelRegister("6rfnk", function(module, exports) {

$parcel$export(module.exports, "CiscoLogo", function () { return $debdeb521bfd1710$export$c0ee1f55c8145cdb; });

var $loA2J = parcelRequire("loA2J");
const $debdeb521bfd1710$export$c0ee1f55c8145cdb = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 79 42",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.2429424,41.0366151 L25.691892,41.0366151 L25.691892,27.4402999 L22.2429424,27.4402999 L22.2429424,41.0366151 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M53.4978468,31.3359257 C53.356853,31.2637727 52.2457684,30.6093615 50.5963441,30.6093615 C48.3677661,30.6093615 46.8208827,32.1541075 46.8208827,34.236813 C46.8208827,36.2574334 48.300305,37.8659425 50.5963441,37.8659425 C52.2181094,37.8659425 53.3463965,37.2252908 53.4978468,37.1447479 L53.4978468,40.7936775 C53.0644091,40.9148275 51.8878872,41.2782774 50.3561825,41.2782774 C46.4764936,41.2782774 43.0720684,38.6176764 43.0720684,34.236813 C43.0720684,30.1757722 46.1526803,27.1987047 50.3561825,27.1987047 C51.9728882,27.1987047 53.1716723,27.590009 53.4978468,27.6863249 L53.4978468,31.3359257 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.5025508,31.3359257 C17.3639182,31.2637727 16.2551948,30.6093615 14.6057704,30.6093615 C12.3721328,30.6093615 10.8262613,32.1541075 10.8262613,34.236813 C10.8262613,36.2574334 12.3077075,37.8659425 14.6057704,37.8659425 C16.2271984,37.8659425 17.354811,37.2252908 17.5025508,37.1447479 L17.5025508,40.7936775 C17.07451,40.9148275 15.8983255,41.2782774 14.3581881,41.2782774 C10.481535,41.2782774 7.08115739,38.6176764 7.08115739,34.236813 C7.08115739,30.1757722 10.161432,27.1987047 14.3581881,27.1987047 C15.9802907,27.1987047 17.1787375,27.590009 17.5025508,27.6863249 L17.5025508,31.3359257 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M64.3466401,30.6607076 C62.3008817,30.6607076 60.78132,32.2621693 60.78132,34.236813 C60.78132,36.215484 62.3008817,37.8156032 64.3466401,37.8156032 C66.3900373,37.8156032 67.9136467,36.215484 67.9136467,34.236813 C67.9136467,32.2621693 66.3900373,30.6607076 64.3466401,30.6607076 M71.5673408,34.236813 C71.5673408,38.1263646 68.5491304,41.2782774 64.3466401,41.2782774 C60.1438125,41.2782774 57.1293124,38.1263646 57.1293124,34.236813 C57.1293124,30.3529666 60.1438125,27.1987047 64.3466401,27.1987047 C68.5491304,27.1987047 71.5673408,30.3529666 71.5673408,34.236813"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.7701066,30.5307315 C38.7188362,30.5142873 37.2663983,30.1155999 36.0736858,30.1155999 C34.6917448,30.1155999 33.9412398,30.5760369 33.9412398,31.2301125 C33.9412398,32.0583621 34.9541685,32.3459674 35.5221911,32.5245042 L36.4730556,32.8262046 C38.7117528,33.5339754 39.7310902,35.0592569 39.7310902,36.7154206 C39.7310902,40.1307757 36.7125425,41.2781767 34.0734636,41.2781767 C32.2381839,41.2781767 30.5206239,40.9425812 30.3512965,40.9070081 L30.3512965,37.7779159 C30.6552088,37.8544316 32.1012378,38.2843294 33.6079819,38.2843294 C35.3231808,38.2843294 36.1124759,37.7839566 36.1124759,37.0144361 C36.1124759,36.325123 35.4297694,35.9271068 34.575037,35.6596372 C34.3655703,35.5905045 34.0518761,35.4928462 33.8383616,35.4237136 C31.917069,34.8189705 30.316554,33.6964036 30.316554,31.4459004 C30.316554,28.9027578 32.229414,27.1945769 35.4085191,27.1945769 C37.0876263,27.1945769 38.6672284,27.5999762 38.7701066,27.6278306 L38.7701066,30.5307315 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M3.42405648,12.8286741 C3.42405648,11.8910203 2.65567435,11.1308966 1.71223062,11.1308966 C0.770136118,11.1308966 6.74611175e-05,11.8910203 6.74611175e-05,12.8286741 L6.74611175e-05,16.3970608 C6.74611175e-05,17.3397485 0.770136118,18.0998723 1.71223062,18.0998723 C2.65567435,18.0998723 3.42405648,17.3397485 3.42405648,16.3970608 L3.42405648,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M12.8283386,8.14366055 C12.8283386,7.20667798 12.0596192,6.44521184 11.1165128,6.44521184 C10.1734064,6.44521184 9.40434963,7.20667798 9.40434963,8.14366055 L9.40434963,16.3969601 C9.40434963,17.3396478 10.1734064,18.0997716 11.1165128,18.0997716 C12.0596192,18.0997716 12.8283386,17.3396478 12.8283386,16.3969601 L12.8283386,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.2328907,1.73395472 C22.2328907,0.796972141 21.4634966,0.0368483835 20.5203902,0.0368483835 C19.5776211,0.0368483835 18.808227,0.796972141 18.808227,1.73395472 L18.808227,19.789327 C18.808227,20.7310079 19.5776211,21.4918029 20.5203902,21.4918029 C21.4634966,21.4918029 22.2328907,20.7310079 22.2328907,19.789327 L22.2328907,1.73395472 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.6367681,8.14366055 C31.6367681,7.20667798 30.8677113,6.44521184 29.9242676,6.44521184 C28.9814985,6.44521184 28.212779,7.20667798 28.212779,8.14366055 L28.212779,16.3969601 C28.212779,17.3396478 28.9814985,18.0997716 29.9242676,18.0997716 C30.8677113,18.0997716 31.6367681,17.3396478 31.6367681,16.3969601 L31.6367681,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.0304588,12.8286741 C41.0304588,11.8910203 40.266799,11.1308966 39.3284148,11.1308966 C38.385983,11.1308966 37.6169263,11.8910203 37.6169263,12.8286741 L37.6169263,16.3970608 C37.6169263,17.3397485 38.385983,18.0998723 39.3284148,18.0998723 C40.266799,18.0998723 41.0304588,17.3397485 41.0304588,16.3970608 L41.0304588,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M50.4383164,8.14366055 C50.4383164,7.20667798 49.6746566,6.44521184 48.7318875,6.44521184 C47.7911422,6.44521184 47.0254585,7.20667798 47.0254585,8.14366055 L47.0254585,16.3969601 C47.0254585,17.3396478 47.7911422,18.0997716 48.7318875,18.0997716 C49.6746566,18.0997716 50.4383164,17.3396478 50.4383164,16.3969601 L50.4383164,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M59.8490074,1.73395472 C59.8490074,0.796972141 59.0846729,0.0368483835 58.1425784,0.0368483835 C57.1987974,0.0368483835 56.4354748,0.796972141 56.4354748,1.73395472 L56.4354748,19.789327 C56.4354748,20.7310079 57.1987974,21.4918029 58.1425784,21.4918029 C59.0846729,21.4918029 59.8490074,20.7310079 59.8490074,19.789327 L59.8490074,1.73395472 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M69.2578432,8.14366055 C69.2578432,7.20667798 68.4941833,6.44521184 67.5298267,6.44521184 C66.5863829,6.44521184 65.8227231,7.20667798 65.8227231,8.14366055 L65.8227231,16.3969601 C65.8227231,17.3396478 66.5863829,18.0997716 67.5298267,18.0997716 C68.4941833,18.0997716 69.2578432,17.3396478 69.2578432,16.3969601 L69.2578432,8.14366055 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M78.6469129,12.8286741 C78.6469129,11.8910203 77.8808919,11.1308966 76.9404839,11.1308966 C75.9973775,11.1308966 75.2316938,11.8910203 75.2316938,12.8286741 L75.2316938,16.3970608 C75.2316938,17.3397485 75.9973775,18.0998723 76.9404839,18.0998723 C77.8808919,18.0998723 78.6469129,17.3397485 78.6469129,16.3970608 L78.6469129,12.8286741 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M76.6735065,39.2465823 L76.6735065,39.4596855 L76.0639953,39.4596855 L76.0639953,41.0366486 L75.8133773,41.0366486 L75.8133773,39.4596855 L75.2011676,39.4596855 L75.2011676,39.2465823 L76.6735065,39.2465823 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M76.8013453,39.2465823 L77.1936317,39.2465823 L77.7312968,40.714477 L77.741416,40.714477 L78.2618785,39.2465823 L78.6467442,39.2465823 L78.6467442,41.0366486 L78.3893801,41.0366486 L78.3893801,39.5677472 L78.3809474,39.5677472 L77.835187,41.0366486 L77.5973865,41.0366486 L77.0644437,39.5677472 L77.052638,39.5677472 L77.052638,41.0366486 L76.8013453,41.0366486 L76.8013453,39.2465823 Z"
            })
        ]
    });

});

parcelRegister("hsIsf", function(module, exports) {

$parcel$export(module.exports, "DominosLogo", function () { return $80701b14ec6746c0$export$3a87515d6bae358a; });

var $loA2J = parcelRequire("loA2J");
const $80701b14ec6746c0$export$3a87515d6bae358a = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 2318.3 500",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1331.1,323.5c-25-58.4-111.2-40.3-134.8-2.8v-29.2h-75.1v207.1h77.8V394.4c0-38.9,8.3-41.7,29.2-43.1 c20.8-1.4,29.2,1.4,29.2,43.1l1.4,104.2h75.1v-107c0-19.5,4.2-37.5,25-37.5c25-1.4,30.6,1.4,30.6,32v114h79.2V345.7 C1470.1,272.1,1365.9,270.7,1331.1,323.5z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M986.4,276.2c-61.2,0-111.2,50-111.2,111.2s50,111.2,111.2,111.2s111.2-50,111.2-111.2 S1047.6,276.2,986.4,276.2z M986.4,426.3c-22.2,0-38.9-18.1-38.9-38.9c0-22.2,18.1-38.9,38.9-38.9c20.8,0,38.9,18.1,38.9,38.9 C1025.4,408.3,1007.3,426.3,986.4,426.3z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M775.2,224.8c-15.3-6.9-30.6-12.5-47.3-13.9c-23.6-2.8-47.3-4.2-70.9-4.2h-86.2v291.9h79.2 c26.4,0,52.8-1.4,77.8-4.2c16.7-2.8,33.4-6.9,48.6-13.9c23.6-12.5,44.5-30.6,59.8-52.8c27.8-45.9,27.8-104.2,0-150.1 C821.1,255.4,800.2,237.3,775.2,224.8z M765.5,387.4c-5.6,9.7-13.9,19.5-25,25c-5.6,2.8-12.5,5.6-19.5,6.9 c-11.1,1.4-20.8,2.8-32,1.4h-32V283.2h36.1c9.7,0,19.5,0,29.2,1.4c6.9,1.4,13.9,2.8,19.5,6.9c9.7,5.6,18.1,13.9,25,25 c5.6,11.1,8.3,23.6,8.3,34.7C773.8,363.8,771,376.3,765.5,387.4z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: 1502.1,
                y: 287.4,
                width: 77.8,
                height: 209.9
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M2140,245.7c2.8-12.5,2.8-26.4-2.8-37.5c-6.9-15.3-22.2-25-38.9-25c-19.5-1.4-37.5,12.5-41.7,30.6 c-5.6,22.2,6.9,44.5,29.2,51.4c5.6,1.4,11.1,0,6.9,6.9c-4.2,5.6-9.7,11.1-15.3,15.3l8.3,12.5 C2119.2,281.8,2135.9,263.7,2140,245.7z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1964.9,276.2c-61.2,0-111.2,50-111.2,111.2s50,111.2,111.2,111.2s111.2-50,111.2-111.2 S2026.1,276.2,1964.9,276.2z M1964.9,426.3c-22.2,0-38.9-18.1-38.9-38.9c0-20.8,18.1-38.9,38.9-38.9s38.9,18.1,38.9,38.9 C2003.8,408.3,1987.1,426.3,1964.9,426.3z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M2227.6,358.2c-38.9,0-36.1-26.4-12.5-27.8c25-1.4,50,5.6,69.5,20.8l25-48.6 c-68.1-40.3-183.5-34.7-186.2,38.9l0,0c-1.4,41.7,30.6,62.5,95.9,69.5c47.3,5.6,33.4,26.4,6.9,29.2c-26.4,2.8-51.4-9.7-77.8-25 l-33.4,50c91.7,58.4,198.7,32,202.9-36.1C2322.1,388.8,2290.1,356.8,2227.6,358.2z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1691.1,320.7v-29.2h-75.1v207.1h75.1V394.4c0-34.7,15.3-41.7,32-43.1c20.8-2.8,36.1,1.4,36.1,43.1l1.4,104.2 h75.1V347.1C1834.3,272.1,1720.3,272.1,1691.1,320.7z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1541,183.1c-23.6,0-43.1,19.5-43.1,43.1c0,23.6,19.5,43.1,43.1,43.1s43.1-19.5,43.1-43.1 C1584.1,202.6,1564.6,183.1,1541,183.1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M494.4,151.1L348.5,5.2l0,0c-6.9-6.9-16.7-6.9-23.6,0L170.6,158.1l169.6,169.6l154.3-152.9l0,0 C501.4,167.8,501.4,158.1,494.4,151.1z M368,190.1c-16.7,16.7-43.1,16.7-58.4,0c-16.7-16.7-16.7-43.1,0-58.4l0,0 c16.7-16.7,43.1-16.7,58.4,0C383.3,147,383.3,173.4,368,190.1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M160.9,169.2L5.2,323.5l0,0l0,0c-6.9,6.9-6.9,16.7,0,23.6l145.9,145.9l0,0c6.9,6.9,16.7,6.9,23.6,0L329,340.2 L160.9,169.2z M130.3,366.6c-16.7,15.3-43.1,15.3-58.4,0c-16.7-16.7-16.7-43.1,0-58.4s43.1-15.3,58.4,0 C145.6,323.5,145.6,349.9,130.3,366.6z M192.8,366.6c-16.7-15.3-16.7-43.1,0-58.4l0,0c16.7-16.7,43.1-16.7,58.4,0 c16.7,16.7,16.7,43.1,0,58.4C234.5,383.3,209.5,383.3,192.8,366.6z"
            })
        ]
    });

});

parcelRegister("gFJSc", function(module, exports) {

$parcel$export(module.exports, "EbayLogo", function () { return $f3e6ba164304e8ca$export$6e7d7fb1946ca256; });

var $loA2J = parcelRequire("loA2J");
const $f3e6ba164304e8ca$export$6e7d7fb1946ca256 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 100 44",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.039,8.84c-12.47,0-13,9.69-12.9,12.23,0,0-.62,11.35,12.58,11.35,11.35,0,11.89-7.12,11.89-7.12h-5.22s-1,3.94-6.67,3.83C5.469,29,5.2,21.95,5.2,21.95h20.11S26.829,8.84,13.039,8.84ZM5.389,18.5s.34-6.34,7.52-6.34,7.15,6.34,7.15,6.34Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M39.249,8.84c-6.26,0-9,3.72-9,3.72V0h-5l.08,26.51s0,3.08-.22,5.14h4.88l.21-3s2.28,3.75,8.94,3.75,11.92-4.09,12.05-11.7S45.549,8.86,39.249,8.84ZM38.1,29c-7.92.11-7.79-8.4-7.79-8.4s-.29-8.2,7.77-8.38,7.79,8.56,7.79,8.56S46.029,28.92,38.1,29Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M74.429,26.4c0-3.43.11-6.48,0-8.65-.13-2.52.11-8.54-10.7-9,0,0-10.39-.94-11.46,6.77h5.3s.4-3.54,5.81-3.43c5.08.11,6,2.6,6,5.68h-5.83c-2.63,0-11.84.3-12.69,5.92-1,6.67,4.92,8.73,9.58,8.7s7.31-1.42,9.27-3.91l.21,3.11h4.63S74.429,29.83,74.429,26.4Zm-13.14,2.81s-5,0-5.33-4c-.32-4.28,7.77-4,7.77-4h5.7S70.339,29.32,61.289,29.21Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("polygon", {
                points: "71.679 9.67 77.509 9.67 86.049 26.69 94.599 9.67 99.869 9.67 84.449 40 78.799 40 83.269 31.57 71.679 9.67"
            })
        ]
    });

});

parcelRegister("b32Sf", function(module, exports) {

$parcel$export(module.exports, "FordLogo", function () { return $8ecf4c15685a11f0$export$22ac95c9dec2accf; });

var $loA2J = parcelRequire("loA2J");
const $8ecf4c15685a11f0$export$22ac95c9dec2accf = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 500 175",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M250,1C112.68,1,1.37,39.72,1.37,87.51S112.68,174,250,174,498.63,135.3,498.63,87.51,387.31,1,250,1Zm0,165.58c-132.49,0-239.89-35.38-239.89-79S117.51,8.46,250,8.46,489.88,43.85,489.88,87.51,382.49,166.55,250,166.55Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M195.67,76.48c6.47-.82,16-1.73,22.16-2.08,1.36-.08,1.64-.06,2.19.61a20.27,20.27,0,0,0,5.91,4.77,4.58,4.58,0,0,0,2.12.78,2.7,2.7,0,0,0,2.07-1,2,2,0,0,0,.47-2.24c-.37-.64-4.63-3-4.77-3.95-.09-.61.58-.74.58-.74a13.9,13.9,0,0,0,8.37-6.81c1.95-3.74,2.27-8.72-1.29-11.48-3.13-2.45-7.85-2.05-11.61,1.32a14.05,14.05,0,0,0-4.4,12.24c.09.72,0,1-.94,1-5.66.45-11.12.61-17.18.93-.41,0-.54-.24-.3-.53,7-12.12,17.41-20.76,29-29.28.76-.57.52-1.67.49-2.58,20.84,4.52,41,12.95,62.58,12.78,8.94-.08,17.49-1.44,25.67-5.93,7.19-3.91,10.11-7.55,10.33-11.31.17-2.62-1.64-4.26-4.22-3.7-21.85,5-42.67,5-64.4,2.33-24.66-3-48.32-9.14-72.85-9.14-3.69,0-7.39.14-11.13.45-23.71,2-46.27,15.35-46.32,35.62,0,10.27,7.28,18.61,18.61,18.24,13.29-.46,24.22-11.11,29.95-24.54,2.17-5.11-1.85-7.22-3.77-4.29a33.85,33.85,0,0,1-13.42,12c-6.27,3.06-12.95,2.23-15-2.85-2.85-7.18,3.08-17.9,16.61-23,19.55-7.24,40-2.45,59.67,1.25.27,0,1.32.58.4,1.05a57,57,0,0,0-12.39,8.14A101.62,101.62,0,0,0,196,57.14c-3.9,4.74-6.67,9-10.32,13.67a1.44,1.44,0,0,1-1.11.64C175.61,73,166.9,74,158.92,79.51c-1.64,1.14-2.35,3.15-1.36,4.71a3.09,3.09,0,0,0,4.38.46,26.85,26.85,0,0,1,15.92-5.61c.25,0,.37.07.45.22a.48.48,0,0,1-.09.41c-8.77,12.17-11,14.92-17.56,22.46a128,128,0,0,1-10.4,10.55c-15,13.91-31.08,13.67-36.87,5a14.83,14.83,0,0,1-.73-15.29c2.79-5.59,8.41-9.67,13.1-12.06,1.74-.89,2.24-3.12.5-5.15-1.1-1.31-3.79-1.55-5.79-1.18-6.13,1.13-13.39,5.77-17.66,11.35a31,31,0,0,0-6.43,22.39c1.46,15.41,14.12,24.29,28.51,24.18,11.46-.09,22.24-3.55,35.22-16.73,12.09-12.29,23.12-30.63,33.45-47.66C193.88,77,194.12,76.67,195.67,76.48Zm30.49-17.79a3,3,0,0,1,3.94-.46c1.15,1,.61,3.43-.56,5.14a9.46,9.46,0,0,1-5.39,3.88H224c-.33,0-.6-.23-.75-1A8.77,8.77,0,0,1,226.16,58.69Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M404,58.15H390.71c-1,0-1.49.13-1.95,1-1.54,2.93-20.15,30.82-23.61,36.23-.57.82-1.29.7-1.38-.23-.34-3.22-3.12-6.91-7.5-8.68a18.91,18.91,0,0,0-10-1.15c-6.12.82-11.57,4-16.37,7.69-7.21,5.5-13.45,12.62-21.49,17.88C304,113.8,298,116.28,294,112.56c-3.64-3.38-3.23-10.88,2.33-16.69.6-.6,1.3-.09,1.19.45a7.36,7.36,0,0,0,2.12,7.07,7.9,7.9,0,0,0,8.88,1,11.59,11.59,0,0,0,6.18-8.91,10.16,10.16,0,0,0-9.32-11.57c-4.64-.32-9.08,1.29-13.4,4.87a25.5,25.5,0,0,0-5.28,5.8c-.47.65-1.17.72-1.14-.26.21-7.57-2.93-11.84-9.19-12-4.87-.11-10.06,2.52-14.12,5.76-4.43,3.56-8.32,8.28-12.48,12.73-.52.55-1,.52-1.11-.54-.13-5-1.4-9.89-3.72-13.34a3.08,3.08,0,0,0-4-1,29.48,29.48,0,0,0-4.72,2.82,2.67,2.67,0,0,0-.8,3A35.14,35.14,0,0,1,234.11,115c-2.79,6.61-8.23,12.55-14.61,14.58-4.2,1.32-8.58.67-11.29-3.06-3.71-5.14-2.21-14.1,3.32-21.52,4.9-6.55,12-10.7,19-13.39a1.1,1.1,0,0,0,.77-1.55c-.39-1.17-1-2.74-1.24-3.46-.66-1.72-2.46-2-4.68-1.76a39.6,39.6,0,0,0-14.31,4.8c-12,6.4-18,18.79-20.58,25.43a25.72,25.72,0,0,1-3.76,6.93c-1.88,2.36-4.25,4.52-8.58,8.32a1.55,1.55,0,0,0-.34,1.76c.44.9,2.7,4.08,3.32,4.38A2,2,0,0,0,183,136a44.67,44.67,0,0,0,8.42-7.52c.63-.74,1.26-.42,1.59.72A18.59,18.59,0,0,0,205,142c11,3.71,22.33-1.64,30.92-11,5.45-5.92,7.43-9.73,9.52-12.32C249,114.29,256,104.47,264.3,98.17c3.05-2.34,6.67-4.12,8.48-2.94,1.46,1,1.93,3.15-.41,7.4-8.49,15.5-21,33.72-23.27,38.13-.43.78,0,1.37.75,1.37,4.45,0,8.85,0,12.88,0a1.51,1.51,0,0,0,1.3-.81c6.52-10.2,12.65-19.9,19.22-29.94.37-.59.71-.13.72.13.15,2.32.71,5.51,2.1,7.6a11.38,11.38,0,0,0,9.9,5.56c3.11,0,4.69-.44,8-1.7a27.46,27.46,0,0,0,6.59-3.53c1-.69,1.16.46,1.13.64-1.51,8.09.36,17.68,8.41,21.66,9.62,4.74,20.2-1.92,26.3-7.95.58-.58,1.22-.52,1.29.73a11.07,11.07,0,0,0,3.07,7c5.1,5.11,15.39,3.08,25.72-4.92,6.63-5.11,13.58-12.35,19.84-20a.89.89,0,0,0,0-1.26c-1-1-2.33-2.13-3.28-3a1.18,1.18,0,0,0-1.43,0c-6.42,6.12-12.21,13.09-20.56,18.85-2.83,2-7.32,3.57-9.34.83-.79-1.06-.7-2.53.08-4.45,2.43-6.08,41-64.82,43-68.3C405.15,58.59,404.79,58.15,404,58.15ZM353.8,108.46c.08.46.66.89,1.23,1.09.21.07.32.23.1.69a59.09,59.09,0,0,1-5.2,8.61,32.38,32.38,0,0,1-6.62,7.14c-3,2.48-6.9,5.13-10.58,5.13a6.64,6.64,0,0,1-3.17-.76c-2-1-2.85-3.81-2.82-6.06.11-6.32,2.92-12.81,8.11-19.19,6.33-7.8,13.33-11.84,17.92-9.63,4.76,2.27,3.25,7.76,1.12,12.09A1.18,1.18,0,0,0,353.8,108.46Z"
            })
        ]
    });

});

parcelRegister("81noK", function(module, exports) {

$parcel$export(module.exports, "NasaLogo", function () { return $71e12af7c89771a6$export$e44efe2f415651b3; });

var $loA2J = parcelRequire("loA2J");
const $71e12af7c89771a6$export$e44efe2f415651b3 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "2.834 70.312 187.088 52.134",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M102.379 121.166h25.672c3.836 0 6.984-1.574 9.541-4.723 2.459-3.049 3.738-6.688 3.738-10.818 0-8.361-10.721-14.263-14.854-14.263h-14.065c-1.082 0-1.969-.492-2.656-1.278-.689-.886-1.082-1.869-1.082-3.05 0-1.377.393-2.557 1.082-3.541.787-.983 1.77-1.573 2.951-1.573h26.361V71.394h-26.854c-4.82 0-8.559 1.476-11.215 4.328-2.359 2.656-3.541 6.197-3.541 10.427 0 4.131 1.182 7.771 3.541 10.72 2.656 3.246 5.805 4.92 9.641 4.92h16.231c.982 0 1.77.295 2.359 1.08.689.787.984 1.771.984 2.854 0 1.279-.492 2.459-1.279 3.443-.885.885-1.869 1.377-3.146 1.377H99.82l-.393-.689-9.738-31.279-.492-.984c-2.361-4.82-6.295-7.18-11.705-7.18-2.951 0-5.607.688-7.968 2.164-2.459 1.475-4.033 3.639-4.918 6.394l-13.083 42.098 11.902.1 12-37.476c.295-1.181.984-1.771 1.869-1.771.492 0 .885.196 1.18.492.295.393.492.787.59 1.279l12.098 37.476h11.217v-.001zM13.851 86.739v34.328H2.834V83.001c0-4.918 1.181-8.361 3.738-10.426 1.967-1.476 4.918-2.263 9.049-2.263 3.344 0 6.197.984 8.754 2.853 2.557 1.869 4.229 4.426 5.115 7.574l7.18 25.279 1.181 3.443c.098.688.492 1.18.885 1.572.492.395.983.592 1.574.395.984-.098 1.476-.689 1.476-1.574V71.493h11.312v37.869c0 4.23-.983 7.379-3.049 9.641-1.967 2.262-4.918 3.443-8.853 3.443-3.443 0-6.296-.689-8.558-1.869-2.754-1.377-4.525-3.541-5.312-6.395l-8.262-28.82-.59-1.869c-.197-.688-.59-1.18-1.082-1.672-.492-.394-1.082-.492-1.672-.394-.59.099-.983.394-1.377.984a3.398 3.398 0 0 0-.492 1.77v2.558zm176.071 34.427-12.787-42.591-.492-.984c-2.361-4.82-6.295-7.18-11.705-7.18-2.951 0-5.607.688-7.967 2.164-2.461 1.475-4.033 3.639-4.92 6.394l-13.082 42.098 11.902.1 12-37.476c.295-1.181.984-1.771 1.869-1.771.492 0 .885.196 1.18.492.297.393.492.787.592 1.279l12.098 37.476h11.312v-.001z"
        })
    });

});

parcelRegister("kKkgA", function(module, exports) {

$parcel$export(module.exports, "PaypalLogo", function () { return $3ea8a3dfeffca036$export$de02d99730715183; });

var $loA2J = parcelRequire("loA2J");
const $3ea8a3dfeffca036$export$de02d99730715183 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        viewBox: "0 0 500 121",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M44,28.51h34.1c18.31,0,25.2,9.26,24.14,22.9C100.52,73.89,86.93,86.33,68.9,86.33H59.8c-2.47,0-4.14,1.63-4.81,6.07l-3.9,25.77c-.26,1.68-1.14,2.66-2.46,2.78H27.25c-2,0-2.73-1.54-2.21-4.88L38.1,33.4C38.63,30.08,40.44,28.51,44,28.51Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M192.08,27c11.5,0,22.12,6.24,20.67,21.79-1.73,18.45-11.67,28.72-27.3,28.76H171.81c-2,0-2.91,1.6-3.43,4.89L165.75,99.2c-.39,2.54-1.69,3.79-3.62,3.79h-12.7c-2,0-2.73-1.29-2.28-4.19l10.5-67.28c.52-3.31,1.78-4.54,4-4.54ZM171.39,63h10.34c6.47-.25,10.77-4.73,11.2-12.81.27-5-3.1-8.56-8.47-8.54l-9.73.05L171.39,63Zm75.88,34.84c1.16-1,2.34-1.6,2.17-.3l-.41,3.12c-.22,1.62.43,2.49,1.95,2.49h11.28c1.9,0,2.83-.77,3.29-3.7l7-43.65c.35-2.19-.18-3.26-1.85-3.26h-12.4c-1.12,0-1.67.62-2,2.33l-.46,2.69c-.24,1.4-.88,1.64-1.48.23-2.1-5-7.47-7.22-15-7.06-17.4.36-29.14,13.57-30.39,30.5-1,13.1,8.42,23.39,20.79,23.39,9,0,13-2.68,17.51-6.78Zm-9.44-6.7c-7.49,0-12.72-6-11.63-13.3a16.2,16.2,0,0,1,15.58-13.3c7.5,0,12.72,6,11.63,13.3a16.21,16.21,0,0,1-15.58,13.3ZM294.6,52.39H283.2c-2.36,0-3.32,1.72-2.57,3.92l14.21,41.6-14,19.79c-1.17,1.65-.27,3.16,1.38,3.16h12.86a4,4,0,0,0,3.83-1.87l43.68-62.68c1.35-1.93.72-4-1.49-4H328.94c-2.09,0-2.93.82-4.12,2.56L306.59,81.35l-8.1-26.49C298,53.23,296.79,52.39,294.6,52.39Z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M388.06,27c11.51,0,22.13,6.24,20.67,21.79C407,67.22,397.07,77.49,381.44,77.53H367.8c-2,0-2.91,1.6-3.43,4.89L361.74,99.2c-.4,2.54-1.7,3.79-3.62,3.79h-12.7c-2,0-2.73-1.29-2.28-4.19l10.5-67.28c.51-3.31,1.78-4.54,4-4.54ZM367.38,63h10.34c6.47-.25,10.77-4.73,11.2-12.81.27-5-3.1-8.56-8.47-8.54l-9.74.05L367.38,63Zm75.88,34.84c1.16-1,2.34-1.6,2.17-.3l-.41,3.12c-.22,1.62.43,2.49,2,2.49h11.28c1.9,0,2.82-.77,3.29-3.7l6.95-43.65c.35-2.19-.18-3.26-1.84-3.26H454.24c-1.12,0-1.66.62-1.95,2.33l-.46,2.69c-.24,1.4-.88,1.64-1.48.23-2.11-5-7.47-7.22-15-7.06-17.41.36-29.14,13.57-30.4,30.5-1,13.1,8.42,23.39,20.79,23.39,9,0,13-2.68,17.52-6.78Zm-9.44-6.7c-7.5,0-12.72-6-11.63-13.3a16.2,16.2,0,0,1,15.58-13.3c7.49,0,12.72,6,11.63,13.3a16.21,16.21,0,0,1-15.58,13.3Zm52,12.09h-13a1.53,1.53,0,0,1-1.6-1.8l11.45-72.49a2.25,2.25,0,0,1,2.17-1.8h13a1.53,1.53,0,0,1,1.6,1.8L488,101.42A2.26,2.26,0,0,1,485.86,103.22Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.72.05H56.86c9.61,0,21,.31,28.64,7,5.1,4.5,7.77,11.66,7.15,19.34C90.56,52.5,75,67.1,54.06,67.1H37.22c-2.86,0-4.76,1.9-5.57,7L27,104c-.3,1.93-1.14,3.08-2.68,3.21h-21c-2.34,0-3.17-1.78-2.56-5.65L15.84,5.72C16.44,1.88,18.54.05,22.72.05Z",
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.14,71.13l6-37.73c.53-3.32,2.34-4.89,5.94-4.89h34.1A33.35,33.35,0,0,1,91.92,31C88.5,54.21,73.49,67.1,53.84,67.1H37C34.79,67.1,33.14,68.23,32.14,71.13Z"
            })
        ]
    });

});

parcelRegister("gLfKe", function(module, exports) {

$parcel$export(module.exports, "SquareLogo", function () { return $120a07dc587b3849$export$dcc1072f6b07484d; });

var $loA2J = parcelRequire("loA2J");
const $120a07dc587b3849$export$dcc1072f6b07484d = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": true,
        fill: "currentColor",
        opacity: 0.8,
        viewBox: "0 0 2048.9 500",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M318.2,303c0,8.4-6.8,15.2-15.1,15.2H197c-8.3,0-15.1-6.8-15.1-15.2V197c0-8.3,6.8-15.1,15.1-15.1h106.1 c8.3,0,15.1,6.8,15.1,15.1V303z M409.1,382.6c0,14.6-11.9,26.5-26.5,26.5H117.4c-14.6,0-26.5-11.9-26.5-26.5V117.4 c0-14.6,11.9-26.5,26.5-26.5h265.2c14.6,0,26.5,11.9,26.5,26.5V382.6z M416.7,0H83.3C37.5,0,0,37.5,0,83.3v333.3 C0,462.5,37.5,500,83.3,500h333.3c45.8,0,83.3-37.5,83.3-83.3V83.3C500,37.5,462.5,0,416.7,0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M731.4,414.2c-29.6,0-58.1-11.4-78.2-31.5c-17.9-17.9-27.8-41.1-27.8-65.4h30c0,16.3,6.7,32,19,44.2 c14.5,14.4,35.3,22.7,57,22.7h0.3c41.9,0,75.9-29.3,75.9-65.3c0-27-15-48.5-87.7-65.3c-29.6-6.8-49.5-16-62.8-28.8 c-14.1-13.7-21-31.9-21-55.8c0-47,42.1-85.3,94-85.3c24.8,0,48.2,8.5,65.9,24.1c18.2,16,28.3,37.6,28.3,60.9h-30 c0-30.3-28.8-54.9-64.2-54.9c-34.7,0-64,25.3-64,55.3c0,27.4,9.4,43.5,60.7,55.3c54.7,12.6,110.8,33.8,110.9,94.5 c0,25.8-11.2,50-31.5,68c-19.9,17.6-46.4,27.3-74.4,27.3H731.4z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M995.8,201.4c-53.9,0-92.8,40.2-92.8,93.7c0,53.1,39.8,92.1,92.8,92.1c51.5,0,90.8-41.9,90.8-92.5 C1086.7,244.1,1047.3,201.4,995.8,201.4 M1085,499.6V368.1h-0.8c-19.5,29.8-53,45.2-88.3,45.2c-68,0-121.9-51-121.9-119.4 c0-68,55.2-118.6,121.9-118.6c35.3,0,68.8,15.3,88.3,45.6h0.8v-39.8h29v318.5H1085z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1530.6,201.4c-53.9,0-92.8,40.2-92.8,93.7c0,53.1,39.8,92.1,92.8,92.1c51.4,0,90.8-41.9,90.8-92.5 C1621.3,244.1,1582,201.4,1530.6,201.4 M1619.7,407.9v-39.8h-0.8c-19.9,29.8-53.1,45.2-88.3,45.2c-68,0-121.9-51-121.9-119.4 c0-68,55.1-118.6,121.9-118.6c35.7,0,68.9,15,88.3,45.6h0.8v-39.8h29v226.8H1619.7z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1735.7,275.2v132.7h-29.1V181.1h29.1v32.8h0.8c12.5-29,34.4-36.5,63.9-38.6V206 C1760.6,209.3,1735.7,234.6,1735.7,275.2"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1930.3,201.4c-45.2,0-81.3,33.2-88.4,77.5H2019C2011.6,234.6,1975.9,201.4,1930.3,201.4 M2048.5,305.1H1842 c2.1,44.8,43.6,82.1,88,82.1c34.8,0,68.8-19.9,81.3-53.5h30.6c-16.5,47.3-61.3,79.6-111.5,79.6c-65.5,0-118.2-53.5-118.2-118.6 c0-64.7,52.7-119.4,117.8-119.4c66.4,0,119,56,119,121.5C2048.9,299.6,2048.5,302.1,2048.5,305.1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M1339.3,408.2v-35.4h-0.8c-13.3,28-42.9,40.9-72.9,40.9c-29.6,0-59.6-10.4-78.3-34.1 c-16.2-20.4-20-47.9-20-73.3V180.3h29.2v125.4c0,47.1,17.1,81.7,69.2,81.7c19.1,0,34.2-5,48.3-18.4c20-19.1,23.7-41.7,23.7-68.3 V180.3h29.2v227.9H1339.3z"
            })
        ]
    });

});




parcelRegister("aYz6E", function(module, exports) {
$parcel$export(module.exports, "ButtonSubmit", function () { return (parcelRequire("6PtZq")).ButtonSubmit; });
parcelRequire("6PtZq");

});
parcelRegister("6PtZq", function(module, exports) {

$parcel$export(module.exports, "ButtonSubmit", function () { return $89a3ae4d6b6ede37$export$883ac606d954afa4; });
/* button-submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $3XfGP = parcelRequire("3XfGP");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");

var $jgJpJ = parcelRequire("jgJpJ");
const $89a3ae4d6b6ede37$export$883ac606d954afa4 = ({ submitting: submitting, hasSubmitted: hasSubmitted, formError: formError, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const { isSubmitting: formContextSubmitting } = (0, $cRAeL.useSignupFormContext)();
    const submitMessage = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });
    const submitButtonStyle = hasRebrandedSignupFormStyles ? (0, $7Knp0._)({}, $89a3ae4d6b6ede37$var$baseSubmitButtonStyle, $89a3ae4d6b6ede37$var$roundedSubmitButtonStyle) : $89a3ae4d6b6ede37$var$baseSubmitButtonStyle;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XfGP.default), {
        style: submitButtonStyle,
        className: (0, $esG4f.default)([
            "_k48p1nn1 _6kab1h6o",
            "SignupSubmitBtn"
        ]),
        shouldFitContainer: true,
        type: "submit",
        appearance: "primary",
        isDisabled: formContextSubmitting || submitting || hasSubmitted && !formError,
        isLoading: formContextSubmitting || submitting || hasSubmitted && !formError,
        onClick: ()=>(0, $jgJpJ.trackSignUpWithEmail)(createAnalyticsEvent),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            id: "SubmitMessage",
            children: submitMessage
        })
    });
};
const $89a3ae4d6b6ede37$var$submitButtonCss = null;
const $89a3ae4d6b6ede37$var$baseSubmitButtonStyle = {
    height: 40
};
const $89a3ae4d6b6ede37$var$roundedSubmitButtonStyle = {
    borderRadius: "40px"
};

});


parcelRegister("swQEv", function(module, exports) {
$parcel$export(module.exports, "EmailForm", function () { return (parcelRequire("aGugh")).EmailForm; });
parcelRequire("aGugh");

});
parcelRegister("aGugh", function(module, exports) {

$parcel$export(module.exports, "EmailForm", function () { return $8b17fed474f10f6b$export$89af2fd9aa25b6d8; });
/* email-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $6oKbD = parcelRequire("6oKbD");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $dWbel = parcelRequire("dWbel");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
parcelRequire("aYz6E");
var $6PtZq = parcelRequire("6PtZq");
parcelRequire("4XUO1");
var $bcjjH = parcelRequire("bcjjH");
parcelRequire("c5qwq");
var $5jy1A = parcelRequire("5jy1A");
parcelRequire("7ubNM");
var $jMrU6 = parcelRequire("jMrU6");
const $8b17fed474f10f6b$export$89af2fd9aa25b6d8 = ()=>{
    const { isEmbedded: isEmbedded, productKey: productKey, edition: edition, formError: formError, hasSubmitted: hasSubmitted, isEmailValid: isEmailValid, onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA, setIsEmailValid: setIsEmailValid, setTypeAheadEmail: setTypeAheadEmail } = (0, $cRAeL.useSignupFormContext)();
    const intl = (0, $f6qj2.default)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const separatorText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.or",
        defaultMessage: "Or continue with"
    });
    (0, $iSvIT.useEffect)(()=>{
        const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
        if (analyticsClient) (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: productKey,
            edition: edition
        });
    }, [
        createAnalyticsEvent,
        productKey,
        edition,
        isEmbedded,
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: onSubmitWithReCAPTCHA,
        isDisabled: false,
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5jy1A.InputEmail), {
                        setIsEmailValid: setIsEmailValid,
                        submitting: submitting,
                        setTypeAheadEmail: setTypeAheadEmail,
                        workCallout: true
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1wybepq8 _vwz4bs82"
                        ]),
                        style: {
                            "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bcjjH.EulaText), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6PtZq.ButtonSubmit), {
                        "data-testid": "signup-form-submit",
                        submitting: submitting,
                        hasSubmitted: hasSubmitted,
                        isEmailValid: isEmailValid,
                        formError: false
                    }),
                    formError && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syazgryn _19pki2wt _2hwxidpf _otyr1tcg _18u0idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpUiSignup.SignupForm.formError",
                            defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>.",
                            values: {
                                contactUsLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: text,
                                        "aria-label": text,
                                        type: "inline",
                                        href: "/company/contact"
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_179r11xk _vwz4400g _19pkviql _2hwx1j6v _otyrviql _18u01j6v _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_bfhku67f _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v"
                            ]),
                            children: separatorText
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jMrU6.SignInButtons), {})
                ]
            }))
    });
};
const $8b17fed474f10f6b$var$formErrorStyle = null;
const $8b17fed474f10f6b$var$legalTextCss = null;
const $8b17fed474f10f6b$var$orSeparatorStyle = null;
const $8b17fed474f10f6b$var$orSeparatorSpanStyle = null;

});
parcelRegister("4XUO1", function(module, exports) {
$parcel$export(module.exports, "EulaText", function () { return (parcelRequire("bcjjH")).EulaText; });
parcelRequire("bcjjH");

});
parcelRegister("bcjjH", function(module, exports) {

$parcel$export(module.exports, "EulaText", function () { return $9d116397159ef9f3$export$76bbdd07dd3614a3; });

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");
const $9d116397159ef9f3$export$76bbdd07dd3614a3 = ()=>{
    const signupBundle = new URLSearchParams(window.location.search).get("bundle");
    const isCompass = signupBundle === "compass";
    const termsOfServiceLinkHref = (0, $3FBn4.useLocalizedHref)("/legal/cloud-terms-of-service");
    const aiTermsLinkHref = (0, $3FBn4.useLocalizedHref)("/legal/product-specific-terms#atlassian-intelligence-specific-terms");
    const privacyPolicyLinkHref = (0, $3FBn4.useLocalizedHref)("/legal/privacy-policy#what-this-policy-covers");
    const messageId = isCompass ? "BxpUiSignup.SignupForm.compass.termsAndConditions" : "BxpUiSignup.SignupForm.termsAndConditions";
    const defaultMessage = isCompass ? "I agree to the <termsOfServiceLink> Atlassian Customer Agreement</termsOfServiceLink>, and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>. Atlassian will collect, use, and process data from across your Atlassian products, which may include data originating from connected third party apps, in accordance with the <termsOfServiceLink> Atlassian Customer Agreement</termsOfServiceLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>." : "I agree to the <termsOfServiceLink>Atlassian Customer Agreement</termsOfServiceLink>, which incorporates by reference the <aiTermsLink>AI Product-Specific Terms</aiTermsLink>, and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: messageId,
        defaultMessage: defaultMessage,
        values: {
            termsOfServiceLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    text: text,
                    "aria-label": text,
                    type: "inline",
                    href: termsOfServiceLinkHref,
                    className: "linkText"
                }),
            aiTermsLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    text: text,
                    "aria-label": text,
                    type: "inline",
                    href: aiTermsLinkHref,
                    className: "linkText"
                }),
            privacyPolicyLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                    text: text,
                    "aria-label": text,
                    type: "inline",
                    href: privacyPolicyLinkHref,
                    className: "linkText"
                })
        }
    });
};

});


parcelRegister("c5qwq", function(module, exports) {
$parcel$export(module.exports, "InputEmail", function () { return (parcelRequire("5jy1A")).InputEmail; });
parcelRequire("5jy1A");

});
parcelRegister("5jy1A", function(module, exports) {

$parcel$export(module.exports, "InputEmail", function () { return $e6d4a1470f96a3f4$export$497a6aaf7dad75ee; });
/* input-email.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $26kkA = parcelRequire("26kkA");

var $bDTBs = parcelRequire("bDTBs");

var $1EpFI = parcelRequire("1EpFI");

var $7OGW4 = parcelRequire("7OGW4");

var $48zDN = parcelRequire("48zDN");

var $jgJpJ = parcelRequire("jgJpJ");

var $6WBIS = parcelRequire("6WBIS");

var $cRAeL = parcelRequire("cRAeL");
const $e6d4a1470f96a3f4$export$497a6aaf7dad75ee = ({ hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, setIsEmailValid: setIsEmailValid, setTypeAheadEmail: setTypeAheadEmail, submitting: submitting, workCallout: workCallout })=>{
    const { isAnimatedHero: isAnimatedHero } = (0, $6WBIS.usePaidJswProductTourContext)();
    const { typeAheadEmail: typeAheadEmail, isReadyForInvalid: isReadyForInvalid, setIsReadyForInvalid: setIsReadyForInvalid } = (0, $cRAeL.useSignupFormContext)();
    const [email, setEmail] = (0, $iSvIT.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $iSvIT.useState)();
    const intl = (0, $f6qj2.default)();
    const errorMessageText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.invalidEmail",
        defaultMessage: "Please enter a valid email address."
    });
    const workCalloutText = workCallout ? intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workCallout",
        defaultMessage: "Find teammates, plus keep work and life separate by using your work email."
    }) : "";
    const labelText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.workEmail",
        defaultMessage: "Work email"
    });
    const placeholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholder",
        defaultMessage: "you@company.com"
    });
    const paidPlaceholderText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.emailPlaceholderPaidExperiment",
        defaultMessage: "Enter work email"
    });
    (0, $iSvIT.useEffect)(()=>{
        if (submitting && !isReadyForInvalid) setIsReadyForInvalid(true);
    }, [
        submitting,
        isReadyForInvalid
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const isValid = (0, $jgJpJ.emailIsValid)(email); // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_6rth7vkz _1rwq12cp _125x1syg _1d6jidpf _18fjglyw"
        ]),
        style: {
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
            "aria-required": true,
            isRequired: true,
            label: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_k48pbfng",
                    isAnimatedHero && "_1q51idpf",
                    "workEmail"
                ]),
                children: labelText
            }),
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        isValid === true && "_1lo61rfg",
                        isValid === false && "_1lo6gryn"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), (0, $6iHNw._)((0, $7Knp0._)({}, fieldProps), {
                            autoComplete: "on",
                            elemAfterInput: /*#__PURE__*/ (0, $loA2J.jsx)($e6d4a1470f96a3f4$var$InputIcon, {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: isAnimatedHero ? paidPlaceholderText : placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email,
                            className: (0, $esG4f.default)([
                                hasRebrandedSignupFormStyles && "_2rko1fu0 _bozgftgi _y4tiftgi"
                            ])
                        })),
                        isValid === false ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_syaz1du8 _1wybepq8 _vwz4bs82 _1pfhi2wt",
                                "errorMessageText"
                            ]),
                            "aria-live": "assertive",
                            role: "alert",
                            style: {
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : workCallout ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1wybepq8 _vwz4bs82 _1pfhi2wt _syazvwuj"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                            },
                            children: workCalloutText
                        }) : null
                    ]
                })
        })
    });
};
const $e6d4a1470f96a3f4$var$InputIcon = ({ valid: valid })=>typeof valid === "undefined" ? null : valid ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswuu67f _1wyb1syg _y4tiftgi _syazuhq2"
        ]),
        style: {
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bDTBs))), {
            label: "",
            size: "medium"
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _lswuu67f _1wyb1syg _y4tiftgi _syaz1du8"
        ]),
        style: {
            "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1EpFI))), {
            label: "",
            size: "medium"
        })
    });
const $e6d4a1470f96a3f4$var$errorMessageCss = null;
const $e6d4a1470f96a3f4$var$helpTextCss = null;
const $e6d4a1470f96a3f4$var$textFieldStyles = null;
const $e6d4a1470f96a3f4$var$fieldCss = null;
const $e6d4a1470f96a3f4$var$iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: (0, $48zDN.N0),
    fontSize: (0, $jgJpJ.fontSize).md,
    paddingInlineEnd: 8
};
const $e6d4a1470f96a3f4$var$iconValidCss = null;
const $e6d4a1470f96a3f4$var$iconInvalidCss = null;
const $e6d4a1470f96a3f4$var$inputInvalidCss = null;
const $e6d4a1470f96a3f4$var$inputValidCss = null;
const $e6d4a1470f96a3f4$var$labelCss = null;
const $e6d4a1470f96a3f4$var$noTopPadding = null;

});
parcelRegister("6WBIS", function(module, exports) {

$parcel$export(module.exports, "usePaidJswProductTourContext", function () { return $b2db430733957aa0$export$28c0cc092f6791a9; });

var $iSvIT = parcelRequire("iSvIT");

var $8cKGP = parcelRequire("8cKGP");
const $b2db430733957aa0$var$defaultValues = {
    isLoggedIn: false,
    paidJiraPageType: (0, $8cKGP.PaidJiraPageType).DEFAULT
};
const $b2db430733957aa0$export$f56a0290ee9b71c2 = /*#__PURE__*/ (0, $iSvIT.createContext)($b2db430733957aa0$var$defaultValues);
const $b2db430733957aa0$export$28c0cc092f6791a9 = ()=>{
    const { isLoggedIn: isLoggedIn, paidJiraPageType: paidJiraPageType } = (0, $iSvIT.useContext)($b2db430733957aa0$export$f56a0290ee9b71c2);
    // if user is logged out and page paid-lp-jsw-features page show animated hero
    const isAnimatedHero = !isLoggedIn && paidJiraPageType === (0, $8cKGP.PaidJiraPageType).PAID_LP_JSW_FEATURES;
    return {
        isLoggedIn: isLoggedIn,
        paidJiraPageType: paidJiraPageType,
        isAnimatedHero: isAnimatedHero
    };
};

});
parcelRegister("8cKGP", function(module, exports) {

$parcel$export(module.exports, "PaidJiraPageType", function () { return $34c280fcea47d3c0$export$334cec9362a8bc36; });
var $34c280fcea47d3c0$export$334cec9362a8bc36;
(function(PaidJiraPageType) {
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_FEATURES"] = 0] = "PAID_LP_JSW_FEATURES";
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_ROADMAPS"] = 1] = "PAID_LP_JSW_ROADMAPS";
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_TEMPLATE"] = 2] = "PAID_LP_JSW_TEMPLATE";
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_TRACKER"] = 3] = "PAID_LP_JSW_TRACKER";
    PaidJiraPageType[PaidJiraPageType["PAID_LP_JSW_PM"] = 4] = "PAID_LP_JSW_PM";
    PaidJiraPageType[PaidJiraPageType["DEFAULT"] = 5] = "DEFAULT";
})($34c280fcea47d3c0$export$334cec9362a8bc36 || ($34c280fcea47d3c0$export$334cec9362a8bc36 = {}));

});




parcelRegister("7ubNM", function(module, exports) {
$parcel$export(module.exports, "SignInButtons", function () { return (parcelRequire("jMrU6")).SignInButtons; });
parcelRequire("jMrU6");

});
parcelRegister("jMrU6", function(module, exports) {

$parcel$export(module.exports, "SignInButtons", function () { return $8455861e08387f3c$export$54801483963f513f; });
/* sign-in-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $g9kzu = parcelRequire("g9kzu");

var $i6iy0 = parcelRequire("i6iy0");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("WKdxa");
var $cRAeL = parcelRequire("cRAeL");
parcelRequire("9A79K");
var $a0vgS = parcelRequire("a0vgS");
const $8455861e08387f3c$export$54801483963f513f = ({ hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, customSignInProviders: customSignInProviders })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { identityCobranding: identityCobranding, redirectTo: redirectTo, edition: edition, bundle: bundle } = (0, $cRAeL.useSignupFormContext)();
    function getLoginOrigin(provider) {
        const metadataId = `wac-signup-${provider}`;
        const originTracingOptions = {
            product: metadataId
        };
        if (!(0, $jgJpJ.isProduction)()) originTracingOptions.id = "static-uuid-for-testing";
        const loginOrigin = new (0, $i6iy0.default)((0, $7Knp0._)({}, originTracingOptions));
        return loginOrigin.encode();
    }
    const providerLabels = {
        google: "Google",
        microsoft: "Microsoft",
        apple: "Apple",
        slack: "Slack"
    };
    const providers = customSignInProviders || [
        "google",
        "microsoft",
        "apple",
        "slack"
    ];
    const buttons = providers.map((provider)=>{
        const continueUrl = new URL(redirectTo);
        continueUrl.searchParams.append("social-signup-login", "true");
        const params = new URLSearchParams({
            application: identityCobranding,
            continue: continueUrl.href,
            prompt: "select_account",
            atlOrigin: encodeURIComponent(getLoginOrigin(provider))
        });
        return {
            provider: provider,
            label: providerLabels[provider],
            href: `${(0, $jgJpJ.getIdentityBaseUrl)()}/login/initiate/${provider}?${params}`
        };
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            buttons.length > 1 && "_1e0c11p5 _zulp7vkz _yv0efsjm"
        ]),
        children: buttons.map(({ provider: provider, label: label, href: href })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $a0vgS.LogoButton), {
                hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
                href: href,
                onClick: ()=>(0, $jgJpJ.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle), edition),
                type: provider,
                label: label
            }, provider))
    });
};
const $8455861e08387f3c$var$buttonGridCss = null;

});
parcelRegister("9A79K", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("a0vgS")).LogoButton; });
parcelRequire("41onJ");

});
parcelRegister("41onJ", function(module, exports) {
$parcel$export(module.exports, "LogoButton", function () { return (parcelRequire("a0vgS")).LogoButton; });
parcelRequire("a0vgS");

});
parcelRegister("a0vgS", function(module, exports) {

$parcel$export(module.exports, "LogoButton", function () { return $1ad1d28ba144220d$export$ce671d21b66bb548; });
/* logo-button.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $el2uA = parcelRequire("el2uA");
const $1ad1d28ba144220d$var$ProviderLogo = ({ logo: logo })=>{
    switch(logo){
        case "google":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $el2uA.GoogleLogo), {});
        case "microsoft":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $el2uA.MicrosoftLogo), {});
        case "apple":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $el2uA.AppleLogo), {});
        case "slack":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $el2uA.SlackLogo), {});
    }
};
const $1ad1d28ba144220d$export$ce671d21b66bb548 = ({ hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, href: href, onClick: onClick, type: type, label: label })=>/*#__PURE__*/ (0, $loA2J.jsxs)("a", {
        href: href,
        onClick: onClick,
        id: `${type}-social-button`,
        "aria-label": type,
        className: (0, $esG4f.default)([
            "_4cvr1h6o _bfhku67f _2rko1l7b _16qs1yxe _syaz1nct _1e0c1txw _zulp1kwk _4t3i1ylp _1bah1h6o _ca0q1kwk _u5f3oqnp _n3td1kwk _19bvoqnp _4bfu1snc _1hmsagmp _ajmmvv82 _jomr1hxd _irr31hxd _f8pj1nct _30l31nct _1ah3t94y",
            hasRebrandedSignupFormStyles && "_2rko1ylp"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($1ad1d28ba144220d$var$ProviderLogo, {
                logo: type
            }),
            " ",
            label
        ]
    });
const $1ad1d28ba144220d$var$roundedLogoButtonCss = null;
const $1ad1d28ba144220d$var$logoButtonCss = null;

});
parcelRegister("el2uA", function(module, exports) {

$parcel$export(module.exports, "AppleLogo", function () { return $1f406bb1f2678d1f$export$570c8af14df4c066; });
$parcel$export(module.exports, "GoogleLogo", function () { return $1f406bb1f2678d1f$export$deb5eaa840e39fbf; });
$parcel$export(module.exports, "MicrosoftLogo", function () { return $1f406bb1f2678d1f$export$416f81fce45348; });
$parcel$export(module.exports, "SlackLogo", function () { return $1f406bb1f2678d1f$export$741d0a87d063b83b; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $1f406bb1f2678d1f$export$570c8af14df4c066 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        viewBox: "0 0 170 170",
        className: (0, $esG4f.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.197-2.12-9.973-3.17-14.34-3.17-4.58 0-9.492 1.05-14.746 3.17-5.262 2.13-9.501 3.24-12.742 3.35-4.929.21-9.842-1.96-14.746-6.52-3.13-2.73-7.045-7.41-11.735-14.04-5.032-7.08-9.169-15.29-12.41-24.65-3.471-10.11-5.211-19.9-5.211-29.378 0-10.857 2.346-20.221 7.045-28.068 3.693-6.303 8.606-11.275 14.755-14.925s12.793-5.51 19.948-5.629c3.915 0 9.049 1.211 15.429 3.591 6.362 2.388 10.447 3.599 12.238 3.599 1.339 0 5.877-1.416 13.57-4.239 7.275-2.618 13.415-3.702 18.445-3.275 13.63 1.1 23.87 6.473 30.68 16.153-12.19 7.386-18.22 17.731-18.1 31.002.11 10.337 3.86 18.939 11.23 25.769 3.34 3.17 7.07 5.62 11.22 7.36-.9 2.61-1.85 5.11-2.86 7.51zM119.11 7.24c0 8.102-2.96 15.667-8.86 22.669-7.12 8.324-15.732 13.134-25.071 12.375a25.222 25.222 0 0 1-.188-3.07c0-7.778 3.386-16.102 9.399-22.908 3.002-3.446 6.82-6.311 11.45-8.597 4.62-2.252 8.99-3.497 13.1-3.71.12 1.083.17 2.166.17 3.24z"
        })
    });
const $1f406bb1f2678d1f$export$deb5eaa840e39fbf = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 18 18",
        className: (0, $esG4f.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z",
                fill: "#EA4335"
            })
        ]
    });
const $1f406bb1f2678d1f$export$416f81fce45348 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 21 21",
        className: (0, $esG4f.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#f25022",
                d: "M1 1h9v9H1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#00a4ef",
                d: "M1 11h9v9H1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#7fba00",
                d: "M11 1h9v9h-9z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffb900",
                d: "M11 11h9v9h-9z"
            })
        ]
    });
const $1f406bb1f2678d1f$export$741d0a87d063b83b = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 127 127",
        className: (0, $esG4f.default)([
            "_1e0c1ule _1bsbf6fq _4t3if6fq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M27.2 80c0 7.3-5.9 13.2-13.2 13.2C6.7 93.2.8 87.3.8 80c0-7.3 5.9-13.2 13.2-13.2h13.2V80zm6.6 0c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V80z",
                fill: "#E01E5A"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M47 27c-7.3 0-13.2-5.9-13.2-13.2C33.8 6.5 39.7.6 47 .6c7.3 0 13.2 5.9 13.2 13.2V27H47zm0 6.7c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H13.9C6.6 60.1.7 54.2.7 46.9c0-7.3 5.9-13.2 13.2-13.2H47z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M99.9 46.9c0-7.3 5.9-13.2 13.2-13.2 7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H99.9V46.9zm-6.6 0c0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V13.8C66.9 6.5 72.8.6 80.1.6c7.3 0 13.2 5.9 13.2 13.2v33.1z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M80.1 99.8c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2-7.3 0-13.2-5.9-13.2-13.2V99.8h13.2zm0-6.6c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2h33.1c7.3 0 13.2 5.9 13.2 13.2 0 7.3-5.9 13.2-13.2 13.2H80.1z",
                fill: "#ECB22E"
            })
        ]
    });
const $1f406bb1f2678d1f$var$logoCss = null;

});








parcelRegister("5CXM7", function(module, exports) {
$parcel$export(module.exports, "ExistingProductText", function () { return (parcelRequire("9cpbu")).ExistingProductText; });
parcelRequire("9cpbu");

});
parcelRegister("9cpbu", function(module, exports) {

$parcel$export(module.exports, "ExistingProductText", function () { return $c2a715d391cd7e2d$export$2421ab9e56e71ee7; });
/* existing-product-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $lrVTP = parcelRequire("lrVTP");
const $c2a715d391cd7e2d$var$existingText = (0, $6x1qA.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct",
    defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
});
const $c2a715d391cd7e2d$export$2421ab9e56e71ee7 = ({ messageOverride: messageOverride, productName: productName, bgColor: bgColor = "bgWhite" })=>{
    const location = (0, $lrVTP.useLocation)();
    const loginUrl = new URL("/login", (0, $jgJpJ.getIdentityBaseUrl)());
    const continueParam = (0, $jgJpJ.getContinueParam)(location);
    if (continueParam) loginUrl.searchParams.append("continue", continueParam);
    else {
        const defaultContinueUrl = new URL("/gateway/api/start/authredirect", (0, $jgJpJ.getWacIntegrationUrl)()).toString();
        loginUrl.searchParams.append("continue", defaultContinueUrl);
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        className: (0, $esG4f.default)([
            "_19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, messageOverride !== null && messageOverride !== void 0 ? messageOverride : $c2a715d391cd7e2d$var$existingText), {
            values: {
                product: productName,
                logInLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: text,
                        "aria-label": text,
                        type: "inline",
                        href: loginUrl.toString(),
                        bgColor: bgColor,
                        className: "linkText"
                    })
            }
        }))
    });
};
const $c2a715d391cd7e2d$var$existingProductCss = null;

});




//# sourceMappingURL=confirmation-page.b3ae3789.js.map
